export default __webpack_public_path__ + "static/media/RivaX_PNG_colorida.78ffa8f5.png";